function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M19.74 8.831C19.566 8.634 15.368 4 10 4S.435 8.634.26 8.832a.992.992 0 0 0 0 1.337C.434 10.366 4.632 15 10 15s9.565-4.634 9.74-4.832a.992.992 0 0 0 0-1.337zm-8.1-2.047c.36-.188.864.027 1.123.48.26.455.178.975-.183 1.163-.36.188-.864-.028-1.124-.481-.26-.454-.178-.975.183-1.162zM10 13.32c-3.749 0-6.904-2.746-7.996-3.821.738-.726 2.417-2.214 4.583-3.103a3.746 3.746 0 0 0-.67 2.135c0 2.15 1.828 3.894 4.083 3.894s4.083-1.744 4.083-3.894c0-.79-.247-1.522-.67-2.135 2.167.89 3.845 2.377 4.583 3.103-1.092 1.076-4.247 3.821-7.996 3.821z"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.d0f20822.svg";
export { ForwardRef as ReactComponent };